import axios from 'axios';
import cache from '@/helpers/cache';
import { event } from 'vue-analytics';
const axData = axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URL,
    withCredentials: true,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    },
    data: {}
});
const dataOnly = (v) => v.data.data;
export default {
    http: axData,
    setToken(token) {
        this.http.defaults.headers['Authorization'] = 'token ' + token;
    },
    async getHistogramData(req) {
        const key = `/data/histogram[${req.from_millis}-${req.to_millis}, ${req.source}, ${req.tz}]`;
        return dataOnly(await cache(key, 60 * 15, () => {
            event('api', 'post', key);
            return this.http.post('/data/histogram', req || {});
        }));
    },
    async getDaily(req) {
        const key = `/data/daily[${req.from_millis}-${req.to_millis}, ${req.source}, ${req.tz}]`;
        return dataOnly(await cache(key, 60 * 15, () => {
            event('api', 'post', key);
            return this.http.post('/data/daily', req || {});
        }));
    },
    async getLocation(req) {
        const key = `/data/location[${req.from_millis}-${req.to_millis}, ${req.source}, ${req.tz}]`;
        return dataOnly(await cache(key, 60 * 15, () => {
            event('api', 'post', key);
            return this.http.post('/data/location', req || {});
        }));
    },
    async downloadData(req) {
        let pids = '';
        for (let id in req.profile_ids) {
            pids += `${id}:${req.profile_ids[id]}|`;
        }
        const key = `/data/request_csv_download_link[${req.from_millis}-${req.to_millis}, ${pids}, ${req.tz}]`;
        event('api', 'post', key);
        let res = null;
        try {
            res = await this.http.post('/data/request_csv_download_link', req || {});
        }
        catch (err) {
            console.log('err', err);
        }
        let id = dataOnly(res).id;
        window.open(process.env.VUE_APP_API_BASE_URL + '/data/download?id=' + id);
    }
};
